// src/ResetPasswordScreen.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, AlertCircle } from 'lucide-react';
import ReportIssueModal from './components/ReportIssueModal';

export default function ResetPasswordScreen() {
  const navigate = useNavigate();
  const [opsId, setOpsId] = useState('');
  const [cpf, setCpf] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erro, setErro] = useState('');
  const [isReportModalVisible, setIsReportModalVisible] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (senha !== confirmarSenha) {
      setErro('As senhas não coincidem.');
      return;
    }

    try {
      await axios.post('/api/reset-password', {
        ops_id: opsId,
        cpf: cpf,
        new_password: senha,
      });

      // Se deu certo, vai para a tela de sucesso
      navigate('/reset-password-success');
    } catch (error) {
      console.error('Erro ao redefinir senha:', error);

      // Se deu erro, vai para a tela de erro
      navigate('/reset-password-error');
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* Cabeçalho Laranja */}
      <div style={styles.header}>
        <img
          src={process.env.PUBLIC_URL + '/ic_target.png'}
          alt="SPX Logo"
          style={styles.logo}
        />
      </div>

      {/* Painel Branco */}
      <div style={styles.container}>
        <button onClick={() => navigate('/')} style={styles.backButton}>
          <ArrowLeft size={20} />
          <span style={styles.backText}>Voltar</span>
        </button>

        <h2 style={styles.title}>Redefinir Senha</h2>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Dados cadastrais</h3>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Ops Id</label>
              <input
                type="number"
                placeholder="12345"
                value={opsId}
                onChange={(e) => setOpsId(e.target.value)}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>CPF (somente números)</label>
              <input
                type="text"
                placeholder="000.000.000-00"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                required
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.section}>
            <h3 style={styles.sectionTitle}>Criar nova senha</h3>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Senha</label>
              <input
                type="password"
                placeholder="Insira uma senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                style={styles.input}
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Confirmação de Senha</label>
              <input
                type="password"
                placeholder="Confirme sua senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                required
                style={styles.input}
              />
            </div>
          </div>

          {erro && <p style={styles.errorText}>{erro}</p>}

          <button type="submit" style={styles.submitButton}>
            Confirmar Nova Senha
          </button>
        </form>
      </div>

      {/* Botão de relatar problema */}
      <button
        onClick={() => setIsReportModalVisible(true)}
        className="fixed bottom-6 right-6 bg-[#EE4D2D] text-white p-3 rounded-full shadow-lg hover:bg-[#D03F2A] transition-all duration-300 z-40 opacity-80 hover:opacity-100"
        title="Relatar um Problema"
      >
        <AlertCircle size={24} />
      </button>

      <ReportIssueModal
        isVisible={isReportModalVisible}
        onClose={() => setIsReportModalVisible(false)}
        screenName="reset-password"
      />
    </div>
  );
}

// 🎨 Estilos
const styles = {
  wrapper: {
    minHeight: '100vh',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 24,
    paddingBottom: 24,
  },
  logo: {
    height: 64,
    objectFit: 'contain',
  },
  container: {
    width: '100%',
    maxWidth: 400,
    backgroundColor: 'white',
    padding: '24px',
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    marginTop: -16,
    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#555',
    fontSize: 14,
    cursor: 'pointer',
    marginBottom: 24,
  },
  backText: {
    marginLeft: 6,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 24,
  },
  section: {
    marginBottom: 40,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  inputGroup: {
    marginBottom: 12,
  },
  label: {
    fontSize: 13,
    color: '#444',
    marginBottom: 4,
    display: 'block',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #ccc',
    borderRadius: 8,
    fontSize: 14,
  },
  errorText: {
    color: 'red',
    fontSize: 13,
    textAlign: 'center',
    marginBottom: 8,
  },
  submitButton: {
    width: '100%',
    backgroundColor: '#EE4D2D',
    color: 'white',
    border: 'none',
    borderRadius: 8,
    padding: '12px',
    fontWeight: 'bold',
    fontSize: 16,
    cursor: 'pointer',
    marginTop: 24,
  },
};
